"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactQuery = require("react-query");
var _reactI18next = require("react-i18next");
var _core = require("@material-ui/core");
var _axios = _interopRequireDefault(require("axios"));
var _searchField = _interopRequireDefault(require("../search-field"));
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
var _clearstring = _interopRequireDefault(require("../../utils/clearstring"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _core.makeStyles)(theme => {
  var _theme$palette$foregr, _theme$palette$foregr2, _theme$palette$foregr3;
  return {
    container: {
      padding: theme.spacing(4, 2)
    },
    searchWrapper: {
      marginBottom: theme.spacing(4)
    },
    link: {
      background: theme.palette.background.paper,
      color: (_theme$palette$foregr = theme.palette.foreground) === null || _theme$palette$foregr === void 0 || (_theme$palette$foregr = _theme$palette$foregr.menu) === null || _theme$palette$foregr === void 0 ? void 0 : _theme$palette$foregr.navigation,
      display: "block",
      paddingTop: "50%",
      position: "relative",
      transitionProperty: "color",
      transitionDuration: theme.transitions.duration.standard,
      transitionTimingFunction: theme.transitions.easing.sharp,
      "&:hover": {
        color: (_theme$palette$foregr2 = theme.palette.foreground) === null || _theme$palette$foregr2 === void 0 || (_theme$palette$foregr2 = _theme$palette$foregr2.menu) === null || _theme$palette$foregr2 === void 0 ? void 0 : _theme$palette$foregr2.navigationHover
      }
    },
    linkSelected: {
      color: (_theme$palette$foregr3 = theme.palette.foreground) === null || _theme$palette$foregr3 === void 0 || (_theme$palette$foregr3 = _theme$palette$foregr3.menu) === null || _theme$palette$foregr3 === void 0 ? void 0 : _theme$palette$foregr3.navigationSelected
    },
    content: {
      alignItems: "center",
      bottom: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      left: 0,
      position: "absolute",
      right: 0,
      top: 0
    },
    iconWrapper: {
      alignItems: "center",
      display: "flex",
      height: 60,
      justifyContent: "center",
      width: 60
    },
    linkTitle: {
      fontWeight: theme.typography.fontWeightBold,
      margin: theme.spacing(1, 0, 0, 0),
      textAlign: "center"
    }
  };
});
const Team = _ref => {
  var _items;
  let {
    providers
  } = _ref;
  const {
    REACT_APP_PATH,
    REACT_APP_PROVIDER_ID
  } = process.env;
  const {
    t,
    i18n
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  const url = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListEmployeeFilter.api?providers=").concat(providers ? providers : REACT_APP_PROVIDER_ID, "&lang=").concat(i18n.language);
  const {
    data,
    status
  } = (0, _reactQuery.useQuery)(["list-employee-filter", i18n.language, providers], () => _axios.default.get(url));
  let items = [];
  if (status === "success") {
    var _data$data;
    items = data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 || (_data$data = _data$data.groups) === null || _data$data === void 0 ? void 0 : _data$data.items;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: css.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.searchWrapper
  }, /*#__PURE__*/_react.default.createElement(_searchField.default, {
    directlink: true,
    intentions: true,
    placeholder: t("site.team.searchLabel"),
    tag: "employees"
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2
  }, (_items = items) === null || _items === void 0 ? void 0 : _items.map((item, index) => /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4,
    key: index
  }, /*#__PURE__*/_react.default.createElement(Item, {
    id: item.id,
    title: item.title
  })))));
};
const Item = props => {
  const {
    id,
    title
  } = props;
  const css = useStyles();
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  const link = "/" + i18n.language + "/team/department/" + id;
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: css.link,
    to: link
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.content
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.iconWrapper
  }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    fallback: "/img/icons/team/fallback.svg",
    src: "/img/icons/team/" + (0, _clearstring.default)(title) + ".svg",
    size: 48
  })), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.linkTitle,
    dangerouslySetInnerHTML: {
      __html: title
    },
    variant: "body1"
  })));
};
var _default = exports.default = Team;